import React, { useState } from 'react';
import PaletteIcon from '@material-ui/icons/Palette';
import { Tooltip } from '@material-ui/core';
import { labelHelper } from '../../../../helpers/labelHelper';
import Zoom from '@material-ui/core/Zoom';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import './UseTemplateButton.css'

export const UseTemplateButton = (props) => {
    const { id, onClick, active } = props;
    return (
        <React.Fragment>
            <Tooltip  TransitionComponent={Zoom} placement="top" title={labelHelper.getLabel("UseTemplateStyle")}>
                <div className={`panel-badge ${active ? 'panel-badge-active' : ''}`} onClick={onClick} >
                    <PaletteIcon className="panel-icon-sm" />
                </div>
            </Tooltip>
        </React.Fragment >
    )
}
export const SetStyleToAllOfItsType = (props) => {
    const { id, onClick, active } = props;
    return (
        <React.Fragment>
            <Tooltip TransitionComponent={Zoom} placement="top" title={labelHelper.getLabel("SetToAllOfThisType")}>
                <div className={`panel-badge spread ${active ? 'panel-badge-active' : ''}`} onClick={onClick} >
                    <CallSplitIcon className="panel-icon-sm" />
                </div>
            </Tooltip>
        </React.Fragment >
    )
}
export const SetToAuto = (props) => {
    const { id, onClick, active } = props;
    return (
        <React.Fragment>
            <Tooltip TransitionComponent={Zoom} placement="top" title={labelHelper.getLabel("SetToAuto")}>
                <div className={`panel-badge spread ${active ? 'panel-badge-active' : ''}`} onClick={onClick} >
                    <AutorenewIcon className="panel-icon-sm" />
                </div>
            </Tooltip>
        </React.Fragment >
    )
}